export const form = {
  headerTitle: 'SEJA UM REVENDEDOR RIFFEL',
  formTitle: 'Preencha as informações abaixo para podemos te atender',
  resultTitle: 'Abaixo estão as informações dos nossos distribuidores',
  name: 'Razão Social',
  name_placeholder: 'Digite a razão social',
  cnpj: 'CNPJ',
  cnpj_placeholder: 'Digite O CNPJ',
  invalid_feedback_cnpj: 'CNPJ Inválido',
  responsible: 'Responsável',
  responsible_placeholder: 'Digite o nome do responsável da empresa',
  companyType: 'Qual o tipo da empresa?',
  monthlyRevenueAverage: 'Qual a média mensal de vendas da sua empresa?',
  segments: 'Qual o segmento? (selecione mais de um se necessário)',
  products: 'Qual o produto de interesse? (selecione mais de um se necessário)',
  kits: 'Quantos kits de transmissão, (considerando todas as marcas), você vende por mês?',
  already_buy_from: 'Já compra Riffel?',
  buy_from: 'De quem?',
  services:
    'Como você prefere ser atendido? (selecione mais de um se necessário)',
  email: 'E-mail',
  email_placeholder: 'Digite seu e-mail',
  phone: 'WhatsApp',
  phone_placeholder: 'Digite seu numero de WhatsApp',
  state: 'Estado',
  city: 'Cidade',
  city_placeholder: 'Digite a cidade',
  zipcode: 'CEP',
  zipcode_placeholder: 'Digite o CEP',
  uf: 'UF',
  invalid_feedback: '*Campo Obrigatório',
  button: ' Enviar informações',
};

export const optionsTexts = {
  defaultOption: "Selecione uma opção",
  companyType: {
    MEI: "MEI",
    ME: "ME",
    EPP: "EPP",
    LTDA: "LTDA",
    SA: "S/A",
  },
  kits: {
    upTo100: "Até 100",
    from100To300: "De 100 a 300",
    from300To1000: "De 300 a 1000",
    moreThan1000: "Mais de 1000",
  },
  monthlyRevenue: {
    upTo20: "Até R$ 20 mil",
    from20To50: "De R$ 20 mil a R$ 50 mil",
    from50To100: "De R$ 50 mil a R$ 100 mil",
    from100To500: "De R$ 100 mil a R$ 500 mil",
    above500: "Acima de R$ 500 mil",
  },
  segments: {
    workshop: "Oficina",
    ecommerce: "Ecommerce",
    marketplace: "Marketplace",
    retailMotorcycleParts: "Varejo - Loja de motopeças",
    retailMotorcyclePartsWorkshop: "Varejo - Lojas de motopeças – Oficina",
    wholesaler: "Atacadista",
    others: "Outros (não relacionado a motopeças)",
  },
  products: {
    kitTitanium: "Kit Titanium (sem retentor)",
    kitTop: "Kit Top (c/ retentor)",
    horn: "Buzina",
    timingChain: "Corrente de comando",
    kickStarter: "Pedal de partida",
    steeringBox: "Caixa de direção",
    semiKit: "Semi Kit Riffel Carbon",
    timingChainTensionerRatchet: "Acionador Tensor da Corrente de Comando com Catraca",
    bearings: "Rolamentos",
    driveChain: "Corrente de Transmissão Riffel Carbon (para motos de alta cilindrada)",
  },
  services: {
    phone: "Telefone",
    whatsapp: "WhatsApp",
    email: "E-mail",
  },
  buyFrom: {
    yes: "Sim",
    no: "Não",
  },
}

export const result = {
  headerTitleResult: 'Cadastro Recebido',
  hello: "Olá",
  manualReceived: "Seu cadastro foi recebido com sucesso.",
  manualInstruction:
    "Segue abaixo o distribuidor mais próximo para você entrar em contato diretamente.",
  thanksInterest:
    "Agradecemos seu interesse em revender os nossos produtos.",
  registrationReceived: "Seu cadastro foi recebido com sucesso.",
  riffelSoon:
    "Em breve você será atendido pela nossa equipe comercial.",
  distributorSoon:
    "Em breve um dos nossos distribuidores parceiros entrará em contato para realizar seu atendimento.",
  stayAlert: "Fique atento!",
  slogan: "Vá mais longe. Vá com Riffel.",
  cardReseller: {
    email: "Email",
    phone: "Telefone",
    whatsapp: "WhatsApp",
    address: "Endereço",
    city: "Cidade",
    zipcode: "CEP",
    call: "Ligar",
  }
};
